export default "__VITE_ASSET__DxdkC2oc__"